import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import { InteractiveMap, Marker, Popup } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import styled from "styled-components";
import { Button, message, Modal } from "antd";
import { ReactComponent as LiveTrackone } from "../../assets/livetracking/livetrackone.svg";
import { ReactComponent as LiveTrackFour } from "../../assets/livetracking/livetrackfour.svg";
import { ReactComponent as VideoIcon } from "../../assets/images/Video.svg";
import { ReactComponent as Videoon } from "../../assets/images/Video-On.svg";
import { ReactComponent as Info } from "../../assets/images/Info.svg";
import { ReactComponent as Infoon } from "../../assets/images/Info-On.svg";
import { ReactComponent as SpeedIcon } from "../../assets/images/speed (2).svg";
import { ReactComponent as SignalIcon } from "../../assets/images/Signals-2.svg";
import { ReactComponent as LockIcon } from "../../assets/images/locked.svg";
import { ReactComponent as UnLockIcon } from "../../assets/images/unlocked.svg";
import { ReactComponent as Batteryicon } from "../../assets/images/gg_battery.svg";
import { ReactComponent as LowBatteryicon } from "../../assets/images/low-bt.svg";
import { ReactComponent as MovingVehicle } from "../../assets/images/MovingVehicle.svg";
import { ReactComponent as StationaryVehicle } from "../../assets/images/StationaryVehicle.svg";
import { ButtonFilled, Buttontransparent } from "../../Reusablecomponents/UIButtons";
import { CALL_API } from "../../Common/api";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { FlyToInterpolator } from "react-map-gl";
import { pointer } from "@testing-library/user-event/dist/cjs/setup/directApi.js";

dayjs.extend(duration);

export const Newbox = styled.div`

.signal-icons {
  display: flex;
  gap: 6px;
}

.signal-item {
  position: relative;
  cursor: pointer;
}

.signal-tooltip {
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.85);
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
}

.signal-item:hover .signal-tooltip {
  opacity: 1;
}
.marker-wrapper {
  position: relative;
  display: inline-block;
}

/* Wave effect ONLY when isHovered = true */
.vehicle-icon.wave-object {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

/* Pseudo-elements for wave rings */
.marker-wrapper.wave-active .wave-object::before,
.marker-wrapper.wave-active .wave-object::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1);
  border-radius: 50%;
  background: radial-gradient(
    rgba(255, 0, 0, 0.6) 0%,
    rgba(255, 0, 0, 0.25) 60%,
    rgba(255, 0, 0, 0) 100%
  );
  opacity: 0;
  pointer-events: none;
  /* Force hardware acceleration */
  will-change: transform, opacity;
  backface-visibility: hidden;
}

/* First wave */
.marker-wrapper.wave-active .wave-object::before {
  animation: waveGlow 3s ease-out infinite;
  animation-fill-mode: forwards;
}

/* Second wave with delay */
.marker-wrapper.wave-active .wave-object::after {
  animation: waveGlow 3s ease-out infinite 1.5s;
  animation-fill-mode: forwards;
}

@keyframes waveGlow {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.9;
  }
  50% {
    transform: translate(-50%, -50%) scale(2.5);
    opacity: 0.5;
  }
  100% {
    transform: translate(-50%, -50%) scale(4);
    opacity: 0;
  }
}

.marker-wrapper.wave-active .wave-object::before,
.marker-wrapper.wave-active .wave-object::after {
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.marker-wrapper {
  overflow: visible !important;
}

.vehicle-icon.wave-object {
  overflow: visible !important;
}


.marker-wrapper.wave-active svg,
.marker-wrapper.wave-active img {
  position: relative;
  z-index: 10;
}


  body {
    overflow: hidden; /* prevent the whole page from scrolling */
  }
  .mapboxgl-popup-content {
    padding: 0 !important;
    background: #fff;
    border-radius: 20px !important; /* applies to all corners */
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    overflow: hidden; /* ensure the radius clips content properly */
  }

  .mapboxgl-popup-tip {
    border-top-color: #e6faf0; /* matches your popup header background */
    width: 15px;
    height: 15px;
  }

  .mapboxgl-popup {
    z-index: 10 !important; /* very high value to be on top */
  }
  .body-content {
    height: 220px;
    width: 100%;
    padding: 12px 14px;
    border-top: 1px solid #eee;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: #fff;
  }
  .mapbox-marker {
    position: absolute;
    z-index: 10; /* lower than card */
  }
  .zoom_container {
    position: absolute;
    bottom: 100px;
    right: 10px;
    zindex: 1000;
    display: flex;
    flexdirection: row;
    gap: 10px;
  }
  .zoom_Body {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #ccc;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
  .ZoomOut_Btn,
  .ZoomIn_Btn {
    width: 40px;
    height: 40px;
    border: none;
    background: #fff;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    transition: border 0.2s, background 0.2s;
    outline: none; /* removes default focus border */
  }

  .ZoomOut_Btn:hover,
  .ZoomOut_Btn:focus {
    border: 1px solid #fff; /* hover/focus border color */
    background: #f9f9f9;
  }

  .ZoomIn_Btn {
    border-bottom: 1px solid #ccc;
  }

  .ZoomIn_Btn:hover,
  .ZoomIn_Btn:focus {
    border-bottom: 1px solid #fff; /* hover/focus border color */
    background: #f9f9f9;
  }
    .unit-details-popup {
  user-select: text;
  -webkit-user-select: text; 
  -moz-user-select: text; 
  -ms-user-select: text; 
  cursor: text;
}
  .vehicle-marker-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

/* LABEL */
.vehicle-label-bubble {
  position: absolute;
  bottom: -32px; 
  left: -50%;              /* place below marker */
  background: #fff;
  padding: 4px 12px;
  border-radius: 16px;
  border: 2px solid #d9d9d9;   /* default */
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15); /* Ant Design shadow */
}

/* --- ARROW --- */
.vehicle-label-bubble .bubble-arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 8px solid #d9d9d9;    /* arrow border color */
}

/* Inner white fill (optional for perfect AntD style) */
.vehicle-label-bubble .bubble-arrow::after {
  content: "";
  position: absolute;
  top: 2px;
  left: -5px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 7px solid #fff;
}


/* --- STATUS COLORS --- */
.moving {
  border-color: #3CB043 !important;
}
.moving .bubble-arrow {
  border-bottom-color: #3CB043 !important;
}

.idling {
  border-color: #FFA500 !important;
}
.idling .bubble-arrow {
  border-bottom-color: #FFA500 !important;
}

.stationary {
  border-color: #9E9E9E !important;
}
.stationary .bubble-arrow {
  border-bottom-color: #9E9E9E !important;
}
  @keyframes vehicle-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(52, 199, 89, 0.7);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 0 20px rgba(52, 199, 89, 0);
    transform: scale(1.1);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(52, 199, 89, 0);
    transform: scale(1);
  }
}

.vehicle-marker-highlighted {
  animation: vehicle-pulse 1.5s ease-out;
}

.vehicle-marker-wrapper,
.marker-wrapper {
  position: relative;
  transition: transform 0.3s ease;
}

.vehicle-marker-wrapper.highlighted,
.marker-wrapper.highlighted {
  z-index: 1000;
}
`;

export const MAPBOX_TOKEN =
  "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";

const LiveMapcomponent = ({
  LiveVehicleDetailMap,
  LiveDeviceDetailMap,
  companyName,
  selectedFGUIDs = [],
  selectedVehicleFromList,
  vehicleSelectionCounter,
  hoveredVehicle = null,
  MonitorDetails = [],
  visibleFGUIDs = [],
  handleContainerHover,
  markerKeyRef,
  isHoveredRef,
  activeTab,
}) => {
  const fallbackLat = -1.2921; // Nairobi latitude
  const fallbackLng = 36.8219;
  const [viewport, setViewport] = useState({
    latitude: fallbackLat,
    longitude: fallbackLng,
    zoom: 8,
    transitionDuration: 500,
  });

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [isInfoActive, setIsInfoActive] = useState(false);
  const [isTrackingActive, setIsTrackingActive] = useState(false);
  const [isDeviceTrackingActive, setIsDeviceTrackingActive] = useState(false);
  const [isDeviceInfoActive, setIsDeviceInfoActive] = useState(false);
  const [livemapLocationName, setLiveMapLocationName] = useState("Loading...");
  const [statustime, setstatustime] = useState("");
  const [highlightedVehicleId, setHighlightedVehicleId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mapStyle, setMapStyle] = useState(
    "mapbox://styles/mapbox/streets-v11"
  );
  const ZOOM_SPEED = 0.005;
  const MIN_ZOOM = 1;
  const MAX_ZOOM = 20;
  const DOUBLE_CLICK_ZOOM_INCREMENT = 0.5;
  const DOUBLE_CLICK_TRANSITION_DURATION = 1000;
  const SMOOTH_TRANSITION_DURATION = 300;

    const reduxPermissions = useSelector(
      (state) => state?.authTracking?.myPermissionList || {},
    );
    
    const hasPermission = (seccode, action) => {
      if (!seccode || !action) return false;
      const code = seccode.toUpperCase();
      const act = action.toUpperCase();
      return (
        Array.isArray(reduxPermissions?.[code]) &&
        reduxPermissions[code].includes(act)
      );
    };

    const lockAllowed = useMemo(
      () => hasPermission("LIVE", "UL"),
      [reduxPermissions],
    );

  const mapRef = useRef(null);
  const toggleMapStyle = () => {
    setMapStyle((prev) =>
      prev === "mapbox://styles/mapbox/streets-v11"
        ? "mapbox://styles/mapbox/satellite-streets-v11"
        : "mapbox://styles/mapbox/streets-v11"
    );
  };

  const matchesMarkerKey = useCallback((markerKey, item) => {
    if (!markerKey || !item) return false;
    const mk = String(markerKey).trim();
    const candidates = [
      item.FVehicleGUID,
      item.FAssetGUID,
      item.FGUID,
      item.FVehicleID,
      item.FAssetID,
      item.ID,
    ];
    return candidates.some((c) => c !== undefined && c !== null && String(c).trim() === mk);
  }, []);

  const TimeandStaus = useCallback(async (vehicleOrDevice) => {

    if (!vehicleOrDevice) return;

    try {
      setLoading(true);

      const assetGUID = vehicleOrDevice.FAssetGUID;
      const vehGUID = vehicleOrDevice.FVehicleGUID;
      const { data } = await CALL_API(
        "POST",
        "ai/trackinglink/TimeandStaus",
        {
          assetGUID,
          vehGUID,
        }
      );
      setstatustime(data?.FObject);
    } catch (error) {
      console.error("TimeandStaus API error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  //lock unlock api
  const [isUnlockModalVisible, setIsUnlockModalVisible] = useState(false);
  const [unlockConfirmDevice, setUnlockConfirmDevice] = useState(null);
  const [isUnlockConfirmVisible, setIsUnlockConfirmVisible] = useState(false);
  const handleUnlock = async (device) => {
    try {
      const { data, ResponseCode } = await CALL_API(
        "POST",
        `container/deviceUnlock`,
        {
          FAssetGUID: device.FAssetGUID,
        }
      );
      if (data?.Result != 200) {
        message.error(data?.Message);
      } else {
        message.success("Device Unlocked Successfully!");
      }
    } catch (error) {
      console.error("Error unlocking device:", error);
      message.error("An error occurred while unlocking the device.");
    } finally {
      setIsUnlockModalVisible(false);
    }
  };

  const handleVehicleSelect = useCallback((vehicle) => {
    setSelectedLocation(vehicle);
    setSelectedId(vehicle.FVehicleGUID || vehicle.FGUID || null);
    setIsInfoActive(true);
    setIsTrackingActive(false);

    const lat = Number(vehicle?.FLatitude);
    const lng = Number(vehicle?.FLongitude);

    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
      setViewport((prev) => ({
        ...prev,
        latitude: lat,
        longitude: lng,
        zoom: 16,
        transitionDuration: 1000,
        transitionInterpolator: new FlyToInterpolator({
          speed: 1.2,
          curve: 2,
          screenSpeed: 0.5,
        }),
      }));
    }

    setHighlightedVehicleId(vehicle.FVehicleGUID || vehicle.FGUID || null);
    TimeandStaus(vehicle);
  }, [TimeandStaus, setViewport]);

  const handleDeviceSelect = useCallback((device) => {
    setSelectedLocation(device);
    setSelectedId(device.FAssetGUID || device.FGUID || null);
    setIsDeviceInfoActive(true);
    setIsDeviceTrackingActive(false);

    const lat = Number(device?.FLatitude);
    const lng = Number(device?.FLongitude);


    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
      setViewport((prev) => ({
        ...prev,
        latitude: lat,
        longitude: lng,
        zoom: 16, // Zoom in closer for better focus
        transitionDuration: 1000,
        transitionInterpolator: new FlyToInterpolator({
          speed: 1.2,
          curve: 2,
          screenSpeed: 0.5,
        }),
      }));
    }
    setHighlightedVehicleId(device.FAssetGUID || device.FGUID || null);
    TimeandStaus(device);
  }, [TimeandStaus, setViewport]);

  const vehiclesToRender = useMemo(() => {
    const baseArray = Array.isArray(LiveVehicleDetailMap)
      ? LiveVehicleDetailMap
      : LiveVehicleDetailMap
        ? [LiveVehicleDetailMap]
        : [];

    const filtered = baseArray
      .filter((item) => item.FAssetTypeID === 552)
      .filter((item) => {
        if (visibleFGUIDs.length > 0) {
          return visibleFGUIDs.includes(item.FVehicleGUID) ||
            visibleFGUIDs.includes(item.FGUID);
        }
        return selectedFGUIDs.length === 0
          && null;
      })
      .map((item) => {
        // Try multiple ways to match with MonitorDetails
        let matchingMonitor = MonitorDetails.find((monitor) => {
          // Match by ID
          if (monitor.ID && item.FVehicleID && monitor.ID === item.FAssetID) {
            return true;
          }
          return false;
        });

        if (matchingMonitor &&
          matchingMonitor.Lat &&
          matchingMonitor.Lon &&
          matchingMonitor.Lat !== 0 &&
          matchingMonitor.Lon !== 0) {

          return {
            ...item,
            FLatitude: matchingMonitor.Lat,
            FLongitude: matchingMonitor.Lon,
            FSpeed: matchingMonitor.Speed || 0,
            FACC: matchingMonitor.Vehicle?.ACC || 0,
            FOnline: matchingMonitor.RT ? 1 : 0,
          };
        }

        console.warn(` No match for ${item.FVehicleName}, using original coords: (${item.FLatitude}, ${item.FLongitude})`);
        return item;
      });


    return filtered;
  }, [LiveVehicleDetailMap, selectedFGUIDs, visibleFGUIDs, MonitorDetails]);


  const DeviceToRender = useMemo(() => {
    const baseArray = Array.isArray(LiveVehicleDetailMap)
      ? LiveVehicleDetailMap
      : LiveVehicleDetailMap
        ? [LiveVehicleDetailMap]
        : [];

    const filtered = baseArray
      .filter((item) => item.FAssetTypeID === 3701)
      .filter((item) => {
        if (visibleFGUIDs.length > 0) {
          return visibleFGUIDs.includes(item.FAssetGUID) ||
            visibleFGUIDs.includes(item.FGUID) ||
            visibleFGUIDs.includes(item.FVehicleGUID);
        }

        return selectedFGUIDs.length === 0 && null;
      })
      .map((item) => {
        let matchingMonitor = MonitorDetails.find((monitor) => {
          // Match by ID
          if (monitor.ID && item.FAssetID && monitor.ID === item.FAssetID) {
            return true;
          }

          return false;
        });

        if (matchingMonitor &&
          matchingMonitor.Lat &&
          matchingMonitor.Lon &&
          matchingMonitor.Lat !== 0 &&
          matchingMonitor.Lon !== 0) {

          return {
            ...item,
            FLatitude: matchingMonitor.Lat,
            FLongitude: matchingMonitor.Lon,
            FSpeed: matchingMonitor.Speed || 0,
            FACC: matchingMonitor.Vehicle?.ACC || 0,
            FOnline: matchingMonitor.RT ? 1 : 0,
            FBattery: matchingMonitor.Lock?.Bat,
            FLockStatus: matchingMonitor.Lock?.LS,
          };
        }

        console.warn(`No match for device ${item.FAssetID}`);
        return item;
      });

    return filtered;
  }, [LiveVehicleDetailMap, selectedFGUIDs, visibleFGUIDs, MonitorDetails]);


  useEffect(() => {
    if (LiveVehicleDetailMap && LiveVehicleDetailMap.length > 0) {
      const sample = LiveVehicleDetailMap[0];
    }

    if (MonitorDetails && MonitorDetails.length > 0) {
      const sample = MonitorDetails[0];
    }
  }, [LiveVehicleDetailMap, MonitorDetails]);


  useEffect(() => {
    if (selectedVehicleFromList) {
      const lat = Number(selectedVehicleFromList.FLatitude);
      const lng = Number(selectedVehicleFromList.FLongitude);

      if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
        setViewport((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
          zoom: 16,
          transitionDuration: 1000,
          transitionInterpolator: new FlyToInterpolator({
            speed: 1.2,
            curve: 2,
            screenSpeed: 0.5,
          }),
        }));

        setSelectedLocation(selectedVehicleFromList);

        const selectedIdValue = selectedVehicleFromList.FAssetTypeID === 552
          ? (selectedVehicleFromList.FVehicleGUID || selectedVehicleFromList.FGUID)
          : (selectedVehicleFromList.FAssetGUID || selectedVehicleFromList.FGUID);

        setSelectedId(selectedIdValue);

        if (selectedVehicleFromList.FAssetTypeID === 552) {
          setIsInfoActive(true);
          setIsTrackingActive(false);
          setIsDeviceInfoActive(false);
          setIsDeviceTrackingActive(false);
        } else if (selectedVehicleFromList.FAssetTypeID === 3701) {
          setIsDeviceInfoActive(true);
          setIsDeviceTrackingActive(false);
          setIsInfoActive(false);
          setIsTrackingActive(false);
        }
        setHighlightedVehicleId(selectedIdValue);
        setTimeout(() => {
          setHighlightedVehicleId(null);
        }, 1500);

        TimeandStaus(selectedVehicleFromList);
      }
    }
  }, [vehicleSelectionCounter, TimeandStaus]);
  //Signla Icon
  const getSignalStatus = (value, type = 'gps') => {
    const max = 31;
    const percentage = (value / max) * 100;

    if (type === 'gps') {
      if (percentage >= 50) return { status: 'strong', color: '#00BC13' }; // Green
      if (percentage >= 20) return { status: 'weak', color: '#FFA500' };   // Orange
      return { status: 'lost', color: '#FF0000' };                         // Red
    } else {
      if (percentage >= 50) return { status: 'strong', color: '#00BC13' }; // Green
      if (percentage >= 20) return { status: 'weak', color: '#FFA500' };   // Orange
      return { status: 'offline', color: '#FF0000' };                      // Red
    }
  };


  // Signal Icon Component (Signal Bars)
  const SignalIcon = ({ value, type }) => {

    const { status, color } = getSignalStatus(value, type);
    const bars = status === 'strong' ? 4 : status === 'weak' ? 2 : 1;

    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="16" width="3" height="5" rx="1" fill={color} opacity={bars >= 1 ? 1 : 0.3} />
        <rect x="8" y="13" width="3" height="8" rx="1" fill={color} opacity={bars >= 2 ? 1 : 0.3} />
        <rect x="13" y="10" width="3" height="11" rx="1" fill={color} opacity={bars >= 3 ? 1 : 0.3} />
        <rect x="18" y="7" width="3" height="14" rx="1" fill={color} opacity={bars >= 4 ? 1 : 0.3} />
      </svg>
    );
  };
  const handleZoom = (direction) => {
    setViewport((prev) => ({
      ...prev,
      zoom: Math.max(
        MIN_ZOOM,
        Math.min(MAX_ZOOM, prev.zoom + (direction === "in" ? 0.5 : -0.5))
      ),
      transitionDuration: SMOOTH_TRANSITION_DURATION,
      transitionInterpolator: new FlyToInterpolator({
        speed: 1.2,
        curve: 2,
        screenSpeed: 0.5,
      }),
    }));
  };


  useEffect(() => {
    if (activeTab === "TrackRight AI") {
      handleContainerHover(vehiclesToRender);
    } else if (activeTab === "TrackRight AI Cargo") {
      handleContainerHover(DeviceToRender);
    } else if (activeTab === "All") {
      const allDevices = [...vehiclesToRender, ...DeviceToRender];
      handleContainerHover(allDevices);
    }
  }, [hoveredVehicle, activeTab, vehiclesToRender, DeviceToRender, handleContainerHover]);

  useEffect(() => {
    if (selectedLocation?.FLatitude && selectedLocation?.FLongitude) {
      const lat = selectedLocation.FLatitude;
      const lng = selectedLocation.FLongitude;

      fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${MAPBOX_TOKEN}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data?.features?.length > 0) {
            setLiveMapLocationName(data.features[0].place_name);
          } else {
            setLiveMapLocationName("Unknown location");
          }
        })
        .catch((err) => {
          console.error("Geocoding error:", err);
          setLiveMapLocationName("Location unavailable");
        });
    }
  }, [selectedLocation]);
  const flyDebounceRef = useRef(null);
  useEffect(() => {
    if (!hoveredVehicle) return;

    // try coords from hoveredVehicle first
    let lat = hoveredVehicle.FLatitude ?? hoveredVehicle.Lat ?? hoveredVehicle.latitude ?? null;
    let lng = hoveredVehicle.FLongitude ?? hoveredVehicle.Lon ?? hoveredVehicle.longitude ?? null;

    // fallback: try to find full record in maps passed to component
    if ((lat == null || lng == null) && Array.isArray(LiveVehicleDetailMap)) {
      const match = LiveVehicleDetailMap.find((v) => {
        const id = String(v.FVehicleGUID || v.FAssetGUID || v.FGUID || v.ID || "");
        const hv = String(hoveredVehicle.FVehicleGUID || hoveredVehicle.FAssetGUID || hoveredVehicle.FGUID || hoveredVehicle.ID || "");
        return id === hv && (v.FLatitude || v.Lat || v.latitude);
      });
      if (match) {
        lat = match.FLatitude ?? match.Lat ?? match.latitude;
        lng = match.FLongitude ?? match.Lon ?? match.longitude;
      }
    }
    if ((lat == null || lng == null) && Array.isArray(LiveDeviceDetailMap)) {
      const match = LiveDeviceDetailMap.find((d) => {
        const id = String(d.FAssetGUID || d.FGUID || d.ID || "");
        const hv = String(hoveredVehicle.FAssetGUID || hoveredVehicle.FGUID || hoveredVehicle.ID || "");
        return id === hv && (d.FLatitude || d.Lat || d.latitude);
      });
      if (match) {
        lat = match.FLatitude ?? match.Lat ?? match.latitude;
        lng = match.FLongitude ?? match.Lon ?? match.longitude;
      }
    }

    if (lat == null || lng == null) return; // no coords — nothing to do

    // debounce and fly
    if (flyDebounceRef.current) clearTimeout(flyDebounceRef.current);
    flyDebounceRef.current = setTimeout(() => {
      setViewport((prev) => ({
        ...prev,
        latitude: Number(lat),
        longitude: Number(lng),
        zoom: Math.max(prev.zoom, 14), // choose desired hover zoom
        transitionDuration: 700,
        transitionInterpolator: new FlyToInterpolator({ speed: 2 }),
      }));
    }, 80);

    return () => {
      if (flyDebounceRef.current) {
        clearTimeout(flyDebounceRef.current);
        flyDebounceRef.current = null;
      }
    };
  }, [hoveredVehicle, LiveVehicleDetailMap, LiveDeviceDetailMap, setViewport]);

  const renderInfoPanel = (vehicle) => {
    const speed = Number(vehicle?.FSpeed) || 0;
    const isOnline = Number(vehicle?.FOnline) === 1; // 1 = online, 0 = offline
    const engine = Number(vehicle?.FACC); // 1 = open, 0 = close
    let statusText;
    let statusColor;

    let durationText = "";
    let days = 0,
      hours = 0,
      minutes = 0;

    if (statustime?.RGTime) {
      const gpsTime = dayjs.utc(statustime.RGTime);
      const now = dayjs.utc();
      const diffInMillis = now.diff(gpsTime);
      days = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
      hours = Math.floor(
        (diffInMillis % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      minutes = Math.floor((diffInMillis % (1000 * 60 * 60)) / (1000 * 60));

      if (days > 0) durationText += `${days}d `;
      if (hours > 0) durationText += `${hours}h `;
      if (minutes > 0) durationText += `${minutes}min`;
      durationText = durationText.trim();
    }

    if (statustime?.RStatus === 2) {
      statusText = "Idling";
      statusColor = "#FF3B30"; // red (example)
    } else if (statustime?.RStatus === 0) {
      statusText = "Parking";
      statusColor = "#34C759"; // green
    } else if (statustime?.RStatus === 3) {
      statusText = "Offline";
      statusColor = "#FF9500"; // orange
    } else  if (statustime?.RStatus === 1) {
      statusText = "Driving";
      statusColor = "#C7C7CC"; // gray
    }
    else {}
    const statusWithTime = durationText
      ? `${statusText} (${durationText})`
      : statusText;
    // Status color
    const speedValue = vehicle?.FSpeed ?? "--";

    return (
      <Newbox>

        <div className="body-content">
          {/* Location */}
          <div style={{ fontSize: 13, color: "#333", marginBottom: 6 }}>
            Location:{" "}
            <span style={{ color: "#6B7280" }}>
              {livemapLocationName ?? "--"}
            </span>
          </div>
          <div style={{ fontSize: 13, color: "#333", marginBottom: 6 }}>
            Mileage:{" "}
            <span style={{ color: "#6B7280" }}>
              {vehicle?.FMileage ?? "--"} Km
            </span>
          </div>

          {/* GPS Time */}
          <div style={{ fontSize: 13, color: "#333", marginBottom: 6 }}>
            GPS Time:{" "}
            {vehicle?.FGPSTime ? (
              <>
                <span style={{ color: "#6B7280" }}>
                  {new Date(vehicle.FGPSTime).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
                <span style={{ color: "#6B7280", margin: "0 4px" }}>•</span>
                <span style={{ color: "#6B7280" }}>
                  {`${new Date(vehicle.FGPSTime)
                    .getDate()
                    .toString()
                    .padStart(2, "0")}-${(
                      new Date(vehicle.FGPSTime).getMonth() + 1
                    )
                      .toString()
                      .padStart(2, "0")}-${new Date(
                        vehicle.FGPSTime
                      ).getFullYear()}`}
                </span>
              </>
            ) : (
              <span style={{ color: "#6B7280" }}>--</span>
            )}
          </div>

          {/* Run Status */}
          <div style={{ fontSize: 13, color: "#333", marginBottom: 6 }}>
            Run Status:{" "}
            <span style={{ color: "#6B7280" }}>{loading ? "loading..." : statusWithTime ?? "--"}</span>
          </div>

          {/* Lat, Long */}
          <div style={{ fontSize: 13, color: "#333", marginBottom: 6 }}>
            Lat, Long:{" "}
            <span style={{ color: "#6B7280" }}>
              {vehicle?.FLatitude ?? "--"}, {vehicle?.FLongitude ?? "--"}
            </span>
          </div>

          {/* Driver */}
          <div style={{ fontSize: 13, color: "#333", marginBottom: 6 }}>
            Driver:{" "}
            <span style={{ color: "#6B7280" }}>
              {vehicle?.driverName ?? "--"}
            </span>
          </div>

          {/* Phone */}
          <div style={{ fontSize: 13, color: "#333", marginBottom: 6 }}>
            Phone:{" "}
            <span style={{ color: "#6B7280" }}>
              {vehicle?.phonenumber ?? "--"}
            </span>
          </div>
        </div>
      </Newbox>
    );
  };

  const renderTrackingPanel = (vehicle) => {
    const lat = vehicle.FLatitude ? Number(vehicle.FLatitude) : 0;
    const lng = vehicle.FLongitude ? Number(vehicle.FLongitude) : 0;
    if (isNaN(lat) || isNaN(lng)) return <div>No location available</div>;

    // You can adjust zoom/size as needed
    return (
      <div
        style={{
          padding: "0",
          height: 234,
          width: "100%",
          borderTop: "1px solid #eee",
        }}
      >
        <InteractiveMap
          latitude={lat}
          longitude={lng}
          zoom={15}
          width="100%"
          height={234}
          mapStyle="mapbox://styles/mapbox/streets-v11"
          mapboxApiAccessToken={MAPBOX_TOKEN}
          scrollZoom={true} // enable scroll/pinch zoom
          dragPan={true}
          attributionControl={false}
        >
          <Marker latitude={lat} longitude={lng} anchor="bottom">
            <LiveTrackFour
              style={{
                width: "50px",
                height: "50px",
                cursor: "pointer",
              }}
            />
          </Marker>
        </InteractiveMap>
      </div>
    );
  };

  const Row = ({ label, value }) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "150px 1fr",
        marginBottom: 6,
      }}
    >
      <span style={{ fontSize: 13, color: "#333" }}>{label}</span>
      <span style={{ fontSize: 13, color: "#6B7280" }}>{value ?? "--"}</span>
    </div>
  );

  const DevicerenderInfoPanel = (device) => {
    // Speed
    const speed = Number(device?.FSpeed) || 0;
    const isOnline = Number(device?.FOnline) !== 0; // 1 = online, 0 = offline
    const engine = Number(device?.FACC); // 1 = open, 0 = close
    let statusText;
    let statusColor;
    // Duration since last GPS

    let durationText = "";
    let days = 0,
      hours = 0,
      minutes = 0;

    if (statustime?.RGTime) {
      const gpsTime = dayjs.utc(statustime.RGTime);
      const now = dayjs.utc();
      const diffInMillis = now.diff(gpsTime);
      days = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
      hours = Math.floor(
        (diffInMillis % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      minutes = Math.floor((diffInMillis % (1000 * 60 * 60)) / (1000 * 60));

      if (days > 0) durationText += `${days}d `;
      if (hours > 0) durationText += `${hours}h `;
      if (minutes > 0) durationText += `${minutes}min`;
      durationText = durationText.trim();
    }

    // Run status 
    if (!isOnline) {
      statusText = "Offline";
      statusColor = "#FF3B30"; // red (example)
    } else if (speed > 0) {
      statusText = "Moving";
      statusColor = "#34C759"; // green
    } else if (speed === 0 && engine === 1) {
      statusText = "Idle";
      statusColor = "#FF9500"; // orange
    } else if (speed === 0 && engine === 0) {
      statusText = "Stationary";
      statusColor = "#C7C7CC"; // gray
    } else {
      statusText = "Unknown";
      statusColor = "#000000";
    }
    if (speed === 0 && engine === 0 && isOnline) {
      statusText = "Parking";
      statusColor = "#C7C7CC"; // gray
    }
    const statusWithTime = durationText
      ? `${statusText} (${durationText})`
      : statusText;


    // Location
    const locationName = livemapLocationName ?? device?.FVehicleName ?? "--";

    // Backcover parsing
    let backCoverStatus = "Undefined";
    try {
      const desc = JSON.parse(device?.FExpandProto?.FDesc || "{}");
      if (desc?.fBackCover === 0) backCoverStatus = "Closed";
      else if (desc?.fBackCover === 1) backCoverStatus = "Open";
    } catch { }

    // GPS formatted time
    const gpsTime = device?.FGPSTime
      ? `${new Date(device.FGPSTime).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })} • ${new Date(device.FGPSTime)
        .getDate()
        .toString()
        .padStart(2, "0")}-${(new Date(device.FGPSTime).getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${new Date(device.FGPSTime).getFullYear()}`
      : "--";

    return (
      <Newbox>
        <div className="body-content">
          <Row label="Location" value={locationName} />
          <Row label="GPS Time" value={gpsTime} />
          <Row label="Run Status" value={loading ? "loading..." : statusWithTime ?? "--"} />
          <Row label="Mileage" value={`${device?.FMileage ?? "--"} Km`} />
          <Row
            label="Lat, Long"
            value={`${device?.FLatitude ?? "--"}, ${device?.FLongitude ?? "--"
              }`}
          />

          {/* Status section */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "150px 1fr",
              marginBottom: 6,
            }}
          >
            <span style={{ fontSize: 13, color: "#333" }}>Status</span>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                color: "#6B7280",
              }}
            >
              <div>
                Lock Rope:{" "}
                {device?.FLockRope === 1
                  ? "PullOut"
                  : device?.FLockRope === 0
                    ? "Insert"
                    : "Undefined"}
              </div>
              <div>
                Lock State:{" "}
                {device?.FLockStatus === 1
                  ? "Unlock"
                  : device?.FLockStatus === 0
                    ? "Lock"
                    : "Undefined"}
              </div>
              <div>Backcover: {backCoverStatus}</div>
              <div>LBS: {device?.FLocationType ?? "--"}</div>
            </span>
          </div>
        </div>
      </Newbox>
    );
  };

  const renderDeviceTrackingPanel = (device) => {
    const lat = device.FLatitude ? Number(device.FLatitude) : 0;
    const lng = device.FLongitude ? Number(device.FLongitude) : 0;
    if (isNaN(lat) || isNaN(lng)) return <div>No location available</div>;

    // You can adjust zoom/size as needed
    return (
      <div
        style={{
          padding: "0",
          height: 234,
          width: "100%",
          borderTop: "1px solid #eee",
        }}
      >
        <InteractiveMap
          latitude={lat}
          longitude={lng}
          zoom={15}
          width="100%"
          height={234}
          mapStyle="mapbox://styles/mapbox/streets-v11"
          mapboxApiAccessToken={MAPBOX_TOKEN}
          scrollZoom={true}
          dragPan={true}
          attributionControl={false}
        >
          <Marker latitude={lat} longitude={lng} anchor="bottom">
            <LiveTrackFour
              style={{
                width: "50px",
                height: "50px",
                cursor: "pointer",
              }}
            />
          </Marker>
        </InteractiveMap>
      </div>
    );
  };
  return (
    <Newbox>
      <div style={{ width: "100%", height: "100vh", position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            zIndex: 1000,
            display: "flex",
            flexDirection: "row",
            gap: 10,
          }}
        >
          {/* Reset Button */}
          <button
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
            title="Reset Map"
            onClick={() =>
              setViewport((prev) => ({
                ...prev,
                latitude: fallbackLat,
                longitude: fallbackLng,
                zoom: 12,
                transitionDuration: 1000,
                transitionInterpolator: new FlyToInterpolator({ speed: 2 }),
              }))
            }
          >
            {/* SVG icon */}
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <circle cx="11" cy="11" r="4" stroke="#222" strokeWidth="2" />
              <circle cx="11" cy="11" r="1.5" fill="#222" />
              <line
                x1="11"
                y1="2"
                x2="11"
                y2="5"
                stroke="#222"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="11"
                y1="17"
                x2="11"
                y2="20"
                stroke="#222"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="2"
                y1="11"
                x2="5"
                y2="11"
                stroke="#222"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="17"
                y1="11"
                x2="20"
                y2="11"
                stroke="#222"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>

          {/* Map/Satellite Toggle */}
          <div
            style={{
              display: "flex",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #ccc",
              background: "#fff",
            }}
          >
            <button
              onClick={toggleMapStyle}
              style={{
                padding: "5px 20px",
                border: "none",
                background: mapStyle.includes("streets") ? "#f0f0f0" : "#fff",
                outline: "none",
                cursor: "pointer",
              }}
            >
              Map/Satellite
            </button>
          </div>
          {/* Zoom In/Out */}
        </div>
        {/* Zoom Controls Bottom-Right */}
        <div className="zoom_container ">
          <div className="zoom_Body" style={{}}>
            {/* Zoom In */}
            <button
              className="ZoomIn_Btn"
              onClick={() => handleZoom("in")}
              style={{
                width: "40px",
                height: "40px",
                border: "none",
                background: "#fff",
                cursor: "pointer",
                fontSize: "20px",
                fontWeight: "bold",
                borderBottom: "1px solid #ccc",
              }}
            >
              +
            </button>

            {/* Zoom Out */}
            <button className="ZoomOut_Btn" onClick={() => handleZoom("out")}>
              −
            </button>
          </div>
        </div>
        <InteractiveMap
          ref={mapRef}
          {...viewport}
          width="100%"
          height="100%"
          mapStyle={mapStyle}
          scrollZoom={{
            speed: ZOOM_SPEED,
            smooth: true,
            smoothTime: 500,
            smoothEasing: (t) => t * (2 - t),
          }}
          dragPan={{
            inertia: true,
            inertiaDecay: 0.85,
            inertiaDeceleration: 3000,
          }}
          dragRotate={{
            inertia: true,
            inertiaDecay: 0.85,
          }}
          attributionControl={false}
          mapboxApiAccessToken={MAPBOX_TOKEN}
          onViewportChange={(newViewport) => {
            const clampedZoom = Math.min(
              Math.max(newViewport.zoom, MIN_ZOOM),
              MAX_ZOOM
            );

            setViewport({
              latitude: newViewport.latitude,
              longitude: newViewport.longitude,
              zoom: clampedZoom,
            });
          }}
          onDblClick={(event) => {
            event.preventDefault();

            setViewport((currentViewport) => {
              const [longitude, latitude] = event.lngLat;
              const zoom = currentViewport.zoom + DOUBLE_CLICK_ZOOM_INCREMENT;
              const clampedZoom = Math.min(Math.max(zoom, MIN_ZOOM), MAX_ZOOM);

              return {
                ...currentViewport,
                longitude,
                latitude,
                zoom: clampedZoom,
                transitionDuration: DOUBLE_CLICK_TRANSITION_DURATION,
                transitionInterpolator: new FlyToInterpolator({
                  speed: 1.2,
                  curve: 2,
                  screenSpeed: 0.5,
                }),
              };
            });
          }}
          touchZoom={{
            speed: ZOOM_SPEED,
            smooth: true,
            smoothTime: 500,
            smoothEasing: (t) => t * (2 - t),
          }}
          touchRotate={{
            inertia: true,
            inertiaDecay: 0.85,
          }}
          doubleClickZoom={false}
        >
          {/* Vehicle markers */}
          {vehiclesToRender.map((vehicle, idx) => {
            return (
              <React.Fragment key={vehicle.FVehicleGUID || idx}>
                {(() => {
                  const speed = Number(vehicle?.FSpeed);
                  const engine = Number(vehicle?.FACC); // 1 = open, 0 = close
                  const isOffline =
                    vehicle?.FStatus === "Offline" || vehicle?.FOnline === 0; // adjust based on your API

                  let MarkerIcon;

                  if (speed > 0) {
                    // Moving
                    MarkerIcon = (
                      <MovingVehicle
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  } else if (speed === 0 && engine === 1) {
                    // Idle
                    MarkerIcon = (
                      <LiveTrackFour
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  } else if (speed === 0 && engine === 0) {
                    // Stationary (engine off)
                    MarkerIcon = (
                      <StationaryVehicle
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  } else {
                    // Fallback for unexpected cases
                    MarkerIcon = (
                      <StationaryVehicle
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  }
                  const statusClass =
                    speed > 0
                      ? "moving"
                      : speed === 0 && engine === 1
                        ? "idling"
                        : "stationary";
                  return (
                    <Marker
                      latitude={Number(vehicle.FLatitude)}
                      longitude={Number(vehicle.FLongitude)}
                      anchor="bottom"
                      onClick={() => {
                        handleVehicleSelect(vehicle);
                      }}
                    >
                      <div
                        className={`marker-wrapper ${matchesMarkerKey(markerKeyRef.current, vehicle) ? "wave-active wave-okay" : ""
                          }`}
                      >
                        <div className={`vehicle-label-bubble ${statusClass}`}>
                          {vehicle.FVehicleName}
                          <div className="bubble-arrow"></div>
                        </div>
                        <div className="vehicle-icon wave-object" >
                          {MarkerIcon}
                        </div>
                      </div>
                    </Marker>
                  );
                })()}

                {selectedId &&
                  (selectedId === vehicle.FVehicleGUID ||
                    selectedId === vehicle.FGUID) && (
                    <Popup
                      latitude={Number(vehicle.FLatitude)}
                      longitude={Number(vehicle.FLongitude)}
                      closeButton={false} // Remove close button
                      closeOnClick={true} // Close when clicking outside
                      anchor="bottom"
                      onClose={() => {
                        setSelectedLocation(null);
                        setSelectedId(null);
                      }}
                      offset={[0, -20]} // optional offset to avoid marker overlap
                    >
                      <div className="unit-details-popup" style={{
                        userSelect: "text"
                      }}>
                        {/* === HEADER === */}
                        <div
                          style={{
                            background: "#E6FAF0",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {/* First Row: Vehicle Name + Status + Icons */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: " 5px 10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: 600,
                                  fontSize: 14,
                                  color: "#111",
                                }}
                              >
                                {vehicle?.FVehicleName ?? "--"}
                              </span>

                              {/* Status Badge */}
                              {(() => {
                                const speed = Number(vehicle?.FSpeed) || 0;
                                const isOnline = vehicle?.FOnline === 1; // 1 = online, 0 = offline
                                const engine = Number(vehicle?.FACC); // 1 = open, 0 = close

                                let statusText;
                                let statusColor;

                                // Check if the vehicle is offline
                                  if (statustime?.RStatus === 2) {
                                    statusText = "Idling";
                                    statusColor = "#FF9500"; // red (example)FF9500
                                  } else if (statustime?.RStatus === 0) {
                                    statusText = "Parking";
                                    statusColor = "#FF9500"; // greenFF9500
                                  } else if (statustime?.RStatus === 3) {
                                    statusText = "Offline";
                                    statusColor = "#FF3B30"; // orange#FF3B30
                                  } else  if (statustime?.RStatus === 1) {
                                    statusText = "Driving";
                                    statusColor = "#34C759"; // gray34C759
                                  }
                                  else {}

                                return (
                                  <span
                                    style={{
                                      background: statusColor,
                                      color: "#fff",
                                      fontSize: 12,
                                      padding: "2px 8px",
                                      borderRadius: 16,
                                      fontWeight: 500,
                                    }}
                                  >
                                    {statusText}
                                  </span>
                                );
                              })()}
                            </div>

                            {/* Right Side: Icons */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "5px 10px",
                              }}
                            >
                              {/* Info Icon */}
                              <span
                                onClick={() => {
                                  setIsInfoActive((prev) => !prev);
                                  setIsTrackingActive(false);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {isInfoActive ? (
                                  <Infoon style={{ width: 30, height: 30 }} />
                                ) : (
                                  <Info style={{ width: 30, height: 30 }} />
                                )}
                              </span>

                              {/* Video Icon */}
                              <span
                                onClick={() => {
                                  setIsTrackingActive((prev) => !prev);
                                  setIsInfoActive(false);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {isTrackingActive ? (
                                  <Videoon style={{ width: 30, height: 30 }} />
                                ) : (
                                  <VideoIcon style={{ width: 30, height: 30 }} />
                                )}
                              </span>
                            </div>
                          </div>

                          {/* Second Row: Dynamic Info Panel */}
                          {isInfoActive && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: " 4px 15px",
                              }}
                            >
                              {/* Signal */}
                              <div

                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <div

                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",

                                  }}
                                >
                                  <div className="signal-icons">

                                    <div className="signal-item">
                                      <SignalIcon value={vehicle?.FGPSSignal || 0} type="gps" />
                                      <div className="signal-tooltip">
                                        GPS
                                      </div>
                                    </div>

                                    <div className="signal-item">
                                      <SignalIcon value={vehicle?.FCellSignal || 0} type="gsm" />
                                      <div className="signal-tooltip">
                                        GSM
                                      </div>
                                    </div>

                                  </div>

                                </div>
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: "#333",
                                  }}
                                >
                                  Signal
                                </span>
                              </div>

                              {/* Speed */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <SpeedIcon
                                  style={{ width: 30, height: 30, color: "#555" }}
                                />
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: "#333",
                                  }}
                                >
                                  {Number(vehicle?.FSpeed) || 0} km/h
                                </span>
                              </div>
                            </div>
                          )}

                          {/* Tracking Location */}
                          {isTrackingActive && (
                            <div
                              style={{
                                fontSize: 13,
                                fontWeight: 500,
                                color: "#333",
                                padding: " 4px 15px",
                              }}
                            >
                              <strong>Location: </strong>{" "}
                              {livemapLocationName ?? "Loading location..."}
                            </div>
                          )}
                        </div>

                        {/* === BODY === */}
                        {isTrackingActive
                          ? renderTrackingPanel(vehicle)
                          : renderInfoPanel(vehicle)}
                      </div>
                    </Popup>
                  )}
              </React.Fragment>
            );
          })}

          {/* Device markers */}
          {DeviceToRender.map((device, idx) => {

            return (
              <React.Fragment key={device.FAssetGUID || idx}>
                {(() => {
                  const speed = Number(device?.FSpeed);
                  const engine = Number(device?.FACC); // 1 = open, 0 = close
                  const isOffline =
                    device?.FStatus === "Offline" || device?.FOnline === 0; // adjust based on your API

                  let MarkerIcon;

                  if (speed > 0) {
                    // Moving
                    MarkerIcon = (
                      <MovingVehicle
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  } else if (speed === 0 && engine === 1) {
                    // Idle
                    MarkerIcon = (
                      <LiveTrackFour
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  } else if (speed === 0 && engine === 0) {
                    // Stationary (engine off)
                    MarkerIcon = (
                      <StationaryVehicle
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  } else {
                    // Fallback for unexpected cases
                    MarkerIcon = (
                      <StationaryVehicle
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                      />
                    );
                  }
                  const statusClass =
                    speed > 0
                      ? "moving"
                      : speed === 0 && engine === 1
                        ? "idling"
                        : "stationary";
                  return (
                    <Marker
                      latitude={Number(device.FLatitude)}
                      longitude={Number(device.FLongitude)}
                      anchor="bottom"
                      onClick={() => {
                        handleDeviceSelect(device);
                      }}
                    >
                      <div
                        className={`marker-wrapper ${matchesMarkerKey(markerKeyRef.current, device) ? "wave-active wave-okay" : ""
                          }`}
                      >
                        <div className="vehicle-icon wave-object">
                          <LiveTrackone style={{ width: 40, height: 40, cursor: "pointer" }} />
                        </div>

                        <div className={`vehicle-label-bubble ${statusClass}`}>
                          {device?.FAssetID}
                          <div className="bubble-arrow"></div>
                        </div>
                      </div>
                    </Marker>
                  );
                })()}
                {!isUnlockConfirmVisible && selectedId &&
                  (selectedId === device.FAssetGUID ||
                    selectedId === device.FGUID) && (
                    <Popup
                      latitude={Number(device.FLatitude)}
                      longitude={Number(device.FLongitude)}
                      closeButton={false}
                      closeOnClick={true}
                      anchor="bottom"
                      onClose={() => {
                        setSelectedLocation(null);
                        setSelectedId(null);
                      }}
                      offset={[0, 10]}
                    >
                      <div className="unit-details-popup" style={{
                        userSelect: "text"
                      }}>
                        {/* === HEADER === */}
                        <div
                          style={{
                            background: "#E6FAF0",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {/* First Row: Vehicle Name + Status + Icons */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: " 5px 10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: 600,
                                  fontSize: 14,
                                  color: "#111",
                                }}
                              >
                                {device?.FAssetID}
                                {""}({device?.FVehicleName})
                              </span>

                              {/* Status Badge */}
                              {(() => {
                                const speed = Number(device?.FSpeed);
                                const engine = Number(device?.FACC); // 1 = open, 0 = close
                                const isOnline = device?.FOnline === 1; // 1 = online, 0 = offline
                                let statusText;
                                let statusColor;

                                if (!isOnline) {
                                  statusText = "Offline";
                                  statusColor = "#FF3B30"; // red (example)
                                } else if (speed > 0) {
                                  statusText = "Moving";
                                  statusColor = "#34C759"; // green
                                } else if (speed === 0 && engine === 1) {
                                  statusText = "Idle";
                                  statusColor = "#FF9500"; // orange
                                } else if (speed === 0 && engine === 0) {
                                  statusText = "Stationary";
                                  statusColor = "#C7C7CC"; // gray
                                } else {
                                  statusText = "Unknown";
                                  statusColor = "#000000";
                                }
                                return (
                                  <span
                                    style={{
                                      background: statusColor,
                                      color: "#fff",
                                      fontSize: 12,
                                      padding: "2px 8px",
                                      borderRadius: 16,
                                      fontWeight: 500,
                                    }}
                                  >
                                    {statusText}
                                  </span>
                                );
                              })()}
                            </div>

                            {/* Right Side: Icons */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "5px 10px",
                              }}
                            >
                              {/* Info Icon */}
                              <span
                                onClick={() => {
                                  setIsDeviceInfoActive((prev) => !prev);
                                  setIsDeviceTrackingActive(false);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {isDeviceInfoActive ? (
                                  <Infoon style={{ width: 30, height: 30 }} />
                                ) : (
                                  <Info style={{ width: 30, height: 30 }} />
                                )}
                              </span>

                              {/* Video Icon */}
                              <span
                                onClick={() => {
                                  setIsDeviceTrackingActive((prev) => !prev);
                                  setIsDeviceInfoActive(false);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {isDeviceTrackingActive ? (
                                  <Videoon style={{ width: 30, height: 30 }} />
                                ) : (
                                  <VideoIcon style={{ width: 30, height: 30 }} />
                                )}
                              </span>
                            </div>
                          </div>

                          {/* Second Row: Dynamic Info Panel */}
                          {isDeviceInfoActive && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "4px 15px",
                              }}
                            >
                              {/* Signal */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <div

                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",

                                  }}
                                >
                                  <div className="signal-icons">

                                    <div className="signal-item">
                                      <SignalIcon value={device?.FGPSSignal || 0} type="gps" />
                                      <div className="signal-tooltip">
                                        GPS
                                      </div>
                                    </div>

                                    <div className="signal-item">
                                      <SignalIcon value={device?.FCellSignal || 0} type="gsm" />
                                      <div className="signal-tooltip">
                                        GSM
                                      </div>
                                    </div>

                                  </div>
                                </div>
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: "#333",
                                  }}
                                >
                                  Signal
                                </span>
                              </div>
                              {/* Battery */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                {Number(device?.FBattery) > 20 ? (
                                  <Batteryicon style={{ width: 30, height: 30 }} />
                                ) : (
                                  <LowBatteryicon
                                    style={{ width: 30, height: 30 }}
                                  />
                                )}
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: "#333",
                                  }}
                                >
                                  {device?.FBattery ? `${device.FBattery}%` : "--"}
                                </span>
                              </div>

                              {/* Speed */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <SpeedIcon
                                  style={{ width: 30, height: 30, color: "#555" }}
                                />
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: "#333",
                                  }}
                                >
                                  {Number(device?.FSpeed) || 0} km/h
                                </span>
                              </div>


                              <div
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent map click from closing popup

                                  // Open modal only if device is currently locked (FLockStatus === 0)
                                  if (device?.FLockStatus === 0) {
                                    if (!lockAllowed) return;
                                    setUnlockConfirmDevice(device);
                                    setIsUnlockConfirmVisible(true);
                                    setSelectedId(null);
                                  }
                                }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 4,
                                  cursor: device?.FLockStatus === 0 ? "pointer" : "default", // only show pointer when clickable
                                  opacity: device?.FLockStatus === 1 ? 0.5 : 1, // optional: grey out unlocked icon
                                }}
                              >
                                {device?.FLockStatus === 1 ? (
                                  <UnLockIcon style={{ width: 30, height: 30 }} />
                                ) : (
                                  <LockIcon style={{ width: 30, height: 30 }} />
                                )}
                                <span
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: "#333",
                                  }}
                                >
                                  {device?.FLockStatus === 1
                                    ? "Unlocked"
                                    : device?.FLockStatus === 0
                                      ? "Locked"
                                      : "Undefined"}
                                </span>
                              </div>

                            </div>
                          )}

                          {/* Tracking Location */}
                          {isDeviceTrackingActive && (
                            <div
                              style={{
                                fontSize: 13,
                                fontWeight: 500,
                                color: "#333",
                                padding: " 4px 15px",
                              }}
                            >
                              <strong>Location: </strong>{" "}
                              {livemapLocationName ?? "Loading location..."}
                            </div>
                          )}
                        </div>

                        {/* === BODY === */}
                        {isDeviceTrackingActive
                          ? renderDeviceTrackingPanel(device)
                          : DevicerenderInfoPanel(device)}
                      </div>
                    </Popup>
                  )}
              </React.Fragment>
            );
          })}
        </InteractiveMap>
      </div>
      <Modal
        visible={isUnlockConfirmVisible}
        onCancel={() => {
          setIsUnlockConfirmVisible(false);
          setSelectedId(unlockConfirmDevice?.FAssetGUID || null);
        }}
        footer={[

          <Buttontransparent
            key="cancel"
            onClick={() => {
              setIsUnlockConfirmVisible(false);
              setSelectedId(unlockConfirmDevice?.FAssetGUID || null);
            }}
            style={{ marginRight: 8 }}
          >
            Cancel
          </Buttontransparent>,
          <ButtonFilled
            key="ok"
            onClick={() => {
              handleUnlock(unlockConfirmDevice); // API call
              setIsUnlockConfirmVisible(false);
              setSelectedId(unlockConfirmDevice?.FAssetGUID || null);
            }}
          >
            {/* {unlockConfirmDevice?.FLockStatus === 1 ? "Lock" : "Unlock"} */}Unlock
          </ButtonFilled>,
        ]}
      >
        <p>
          Are you sure you want to{" "} unlock this device?
          {/* {unlockConfirmDevice?.FLockStatus === 1 ? "lock" : "unlock"} */}
        </p>
      </Modal>
    </Newbox>
  );
};

export default LiveMapcomponent;
